module.exports = __webpack_public_path__ + "decf6a822ca60f1b4b5ee4d96dcbe48c.svg";